import _ from 'lodash';
import { dataConstants } from "services/redux/data/constants";
import ObjectClass from "utils/objects/object";

export default class ObjectBuildingParkingSpace {
	
	static log = ( value ) => {
		console.prefix('ObjectBuildingParkingSpace', value );
	}
	
	static get = ( objects ) => {
		return ObjectClass.get( objects, dataConstants.BUILDING_PARKING_SPACES );
	}
	
	static filter = ( objects ) => {
		return ObjectClass.filterActive( objects );
	}
	
	static order = ( options ) => {
		return _.orderBy( options, ['default', 'position', 'name'], ['desc', 'asc', 'asc'] );
	}
	
	static filterAndOrder = ( objects ) => {
		return this.order( this.filter( objects ) );
	}
	
	static find = ( buildingGuid, transportKind ) => {
		return _.filter( this.filterAndOrder( ObjectClass.all( dataConstants.BUILDING_PARKING_SPACES ) ), o => {
			return o?.building?.guid === buildingGuid && o.transport_kind === transportKind;
		})
	}
}
